<template>
  <vs-row vs-w="12">
    <vs-col vs-lg="5" vs-sm="12">
      <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <img class="itemImage"
             :src="$root.imagePath + 'default.jpg'"
             alt="Image">
      </vs-row>
      <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" style="position: relative;">
        <vs-chip color="lightgreen" style="position: absolute; top: -15px; color:darkgreen;"><strong>
          <animated-number :duration="300" :formatValue="formatToPrice" :value="getPrice() * qty"/>
        </strong></vs-chip>
        <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-input-number min="1" max="9999" label="Mennyiség:" v-model="qty" id="quantity"/>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <!--<vs-checkbox v-model="withBox" :disabled="!selectedDish">Kér hozzá dobozt?</vs-checkbox> -->
          <h3>Kér hozzá dobozt?</h3>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-radio v-model="withBox" :disabled="!selectedDish" vs-value="igen" id="boxRadioBtn" required>Igen</vs-radio>
          <vs-radio v-model="withBox" :disabled="!selectedDish" vs-value="nem" id="boxRadioBtn" required>Nem</vs-radio>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" style="margin-bottom: 10px;">
          <vs-button size="" @click="addToCart()"
                     :disabled="!selectedDish || isNaN(parseInt(qty)) || parseInt(qty) <= 0 || parseInt(qty) > 9999 || withBox == null">
            Hozzáadás
          </vs-button>
        </vs-row>
      </vs-row>
    </vs-col>
    <vs-col vs-lg="7" vs-sm="12">
      <vs-row v-if="selectedDailyItem">
        <h3>{{ formatDate(selectedDailyItem.MenuDate) }}</h3>
      </vs-row>
      <vs-row class="itemDesc" v-if="selectedDailyItem">
        <vs-divider color="success"><strong>"A" menü</strong></vs-divider>
        <vs-row v-if="selectedDailyItem.IdMainA">
          <vs-row
              v-if="selectedDailyItem && (selectedDailyItem.IdMainB || selectedDailyItem.IdMainC || selectedDailyItem.IdDiet)">
            <vs-radio v-model="selectedDish" vs-name="MainDish" :vs-value="selectedDailyItem.MainAName">
              {{ selectedDailyItem.MainAName }}
            </vs-radio>
          </vs-row>
          <span v-else>
            {{ selectedDailyItem.MainAName }}
          </span>
        </vs-row>
        <vs-row v-if="selectedDailyItem && selectedDailyItem.IdMainB">
          <vs-divider color="success"><strong>"B" menü</strong></vs-divider>
          <vs-radio v-model="selectedDish" vs-name="MainDish" :vs-value="selectedDailyItem.MainBName">
            {{ selectedDailyItem.MainBName }}
          </vs-radio>
        </vs-row>
        <vs-row v-if="selectedDailyItem && selectedDailyItem.IdMainC">
          <vs-divider color="success"><strong>"Tej- és cukormentes" menü</strong></vs-divider>
          <vs-radio v-model="selectedDish" vs-name="MainDish" :vs-value="selectedDailyItem.MainCName">
            {{ selectedDailyItem.MainCName }}
          </vs-radio>
        </vs-row>
        <vs-row v-if="selectedDailyItem && selectedDailyItem.IdDiet">
          <vs-divider color="success"><strong>"Epe kímélő" menü</strong></vs-divider>
          <vs-row>
            <vs-radio v-model="selectedDish" vs-name="MainDish" :vs-value="selectedDailyItem.DietName">
              {{ selectedDailyItem.DietName }}
            </vs-radio>
          </vs-row>
        </vs-row>
        <vs-row v-if="selectedDailyItem.IdExtra">
          <strong>Extra: </strong>
          <vs-row>
            <vs-checkbox v-model="withExtra">{{ selectedDailyItem.ExtraName }}</vs-checkbox>
          </vs-row>
        </vs-row>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>

import AnimatedNumber from "animated-number-vue";
import dayjs from "dayjs";

export default {
  name: "add_to_cart_daily",
  props: ['selectedDailyItem', 'boxPrice'],
  components: {
    AnimatedNumber
  },
  data() {
    return {
      IdSoup: 1,
      selectedAddons: [],
      selectedDish: null,
      withBox: "nem",
      withExtra: false,
      menuName: null,
      qty: 1
    }
  },
  watch: {
    selectedDailyItem() {
      this.withBox = null;
      this.withExtra = false;
      this.qty = 1;
      if (!this.selectedDailyItem.IdMainB && !this.selectedDailyItem.IdMainC && !this.selectedDailyItem.IdDiet)
        this.selectedDish = this.selectedDailyItem.MainAName;
      else
        this.selectedDish = null;
    }
  },
  methods: {
    formatToPrice(value) {
      return `${Number(value).toFixed(0)} HUF`;
    },
    addToCart() {
      let payload = {};
      payload.MenuId = this.selectedDailyItem.MenuId;
      payload.ItemId = this.getId();
      payload.ItemName = '[' + dayjs(this.selectedDailyItem.MenuDate).format('MM-DD') + '] ' + this.menuName;
      payload.ItemQty = isNaN(parseInt(this.qty)) || parseInt(this.qty) <= 0 || parseInt(this.qty) > 9999 ? 1 : parseInt(this.qty);
      payload.ItemPrice = this.getPrice();
      payload.ItemAddons = [];
      payload.MenuDate = this.selectedDailyItem.MenuDate;
      if (this.withBox=="igen") {
        payload.WithBox = this.withBox;
        payload.ItemName += ' (Dobozban)';
      }
      if (this.withExtra) {
        payload.WithExtra = this.selectedDailyItem.IdExtra;
        payload.ItemName += ' (Extrával)';
      }
      this.quantity = 1;
      this.$parent.$emit('addToCartEvent', payload);
    },
    formatDate(date) {
      return dayjs(date).locale('hu').format('YYYY. MMMM. D. - dddd');
    },
    getPrice() {
      if (!this.selectedDailyItem)
        return 0;

      let basePrice = 0;
      switch (this.selectedDish) {
        case this.selectedDailyItem.MainAName:
        basePrice = parseInt(this.selectedDailyItem.MainAPrice) ;
        if (this.selectedDailyItem.SoupName !== undefined) {
          basePrice += parseInt(this.selectedDailyItem.SoupPrice);
        }
          this.menuName = "[A]-" + this.selectedDailyItem.MainAName;
          break;
        case this.selectedDailyItem.MainBName:
          basePrice = parseInt(this.selectedDailyItem.MainBPrice);
          if (this.selectedDailyItem.SoupName !== undefined) {
          basePrice += parseInt(this.selectedDailyItem.SoupPrice);
        }
          this.menuName = "[B]-" + this.selectedDailyItem.MainBName;
          break;
        case this.selectedDailyItem.MainCName:
          basePrice = parseInt(this.selectedDailyItem.MainCPrice);
          this.menuName = this.selectedDailyItem.MainAName;
          break;
        case this.selectedDailyItem.DietName:
          basePrice = parseInt(this.selectedDailyItem.DietPrice);
          this.menuName = this.selectedDailyItem.DietName;
          break;
        default:
          basePrice = 0;
          break;
      }
      if (this.withBox =="igen")
        basePrice += parseInt(this.boxPrice);
      if (this.withExtra)
        basePrice += parseInt(this.selectedDailyItem.ExtraPrice);

      return basePrice;
    },
    getId() {
      let id = [];
      this.selectedDailyItem.IdSoup = 1;
      switch (this.selectedDish) {
        case this.selectedDailyItem.MainAName:
          id.push(this.selectedDailyItem.IdSoup);
          id.push(this.selectedDailyItem.IdMainA);
          break;
        case this.selectedDailyItem.MainBName:
          id.push(this.selectedDailyItem.IdSoup);
          id.push(this.selectedDailyItem.IdMainB);
          break;
        case this.selectedDailyItem.MainCName:
          id.push(this.selectedDailyItem.IdSoup);
          id.push(this.selectedDailyItem.IdMainC);
          break;
        case this.selectedDailyItem.DietName:
          id.push(this.selectedDailyItem.IdSoup);
          id.push(this.selectedDailyItem.IdDiet);
          break;
        default:
          id = [];
          break;
      }
      return id;
    }
  }
}
</script>

<style scoped>

.vs-input-number {
  margin: 15px 0;
}

.itemImage {
  height: 150px;
  border-radius: 5px;
  max-width: 100%;
}

.itemDesc, .itemLabels, .itemAddons {
  margin: 10px 0;
}

button {
  margin-top: 10px;
}

#boxRadioBtn{
  margin: 10px;
}

body > div:nth-child(1) > div.vs-popup > div > div > div.vs-col.vs-xs-.vs-sm-12.vs-lg-5 > div:nth-child(2) > div:nth-child(4) > label:nth-child(1){
  margin: 10px;
}

body > div:nth-child(1) > div.vs-popup > div > div > div.vs-col.vs-xs-.vs-sm-12.vs-lg-5 > div:nth-child(2) > div:nth-child(4) > label:nth-child(2){
  margin: 10px;
}
</style>